import React from "react";
import Index from "./Routes";

function App() {
  return (
    <>
      <Index />
    </>
  );
}

export default App;
